import React, { PureComponent } from "react";
import ProjectionsModal from "./projections-modal";
import AbbreviatedMillionNumberFormat from "../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import { detectMobile } from "../../../services/utils";

class CollapseWidget extends PureComponent {
  constructor(props) {
    super(props);

    this.isMobile = detectMobile();
  }

  /**
   * getObject
   */
  getObject(year) {
    let projection = this.props.projections.find(
      i => i.target_round_number === year
    );

    if (!projection) {
      return {};
    }

    return projection;
  }

  getObjectValue(obj, key) {
    if (key in obj) {
      return obj[key];
    }

    return 0;
  }

  getYearNumber(offset) {
    const { currentRound, roundInUrl } = this.props;
    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    return current_round + offset;
  }

  isObjectEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  getObjectModified(year, offset) {
    let obj = { ...this.getObject(year) };
    delete obj.id;
    obj.target_round_number += offset;

    return obj;
  }

  get year1() {
    return this.getYearNumber(0);
  }

  get year2() {
    return this.getYearNumber(1);
  }

  get year3() {
    return this.getYearNumber(2);
  }

  get objectYear1() {
    return this.getObject(this.year1);
  }

  get objectYear2() {
    const year = this.getObject(this.year2);

    return this.isObjectEmpty(year)
      ? this.getObjectModified(this.year1, 1)
      : year;
  }

  get objectYear3() {
    const year = this.getObject(this.year3);

    return this.isObjectEmpty(year)
      ? this.getObjectModified(this.year1, 2)
      : year;
  }

  /**
   * getUnits
   */
  getUnits = year => this.getObjectValue(this.getObject(year), "units_sold");

  /**
   * getAvgSellingPrice
   */
  getAvgSellingPrice = year =>
    this.getObjectValue(this.getObject(year), "average_selling_price");

  /**
   * getAvgUnitCosts
   */
  getAvgUnitCosts = year =>
    this.getObjectValue(this.getObject(year), "average_unit_costs");

  /**
   * getAvgUnitCosts
   */
  getTotalRevenues = year =>
    this.getUnits(year) * this.getAvgSellingPrice(year);

  /**
   * getCostOfSales
   */
  getCostOfSales = year => this.getUnits(year) * this.getAvgUnitCosts(year);

  /**
   * getGrossProfits
   */
  getGrossProfits = year =>
    this.getTotalRevenues(year) - this.getCostOfSales(year);

  get grossProfitsYear1() {
    return this.getGrossProfits(this.year1);
  }

  /**
   * getTotalOperatingExpenses
   */
  getTotalOperatingExpenses = year =>
    this.getObjectValue(this.getObject(year), "other_operating_costs");

  /**
   * getOperatingProfits
   */
  getOperatingProfits = year =>
    this.getGrossProfits(year) - this.getTotalOperatingExpenses(year);

  get operatingProfitsYear1() {
    return this.getOperatingProfits(this.year1);
  }

  /**
   * getNonOperatingExpenses
   */
  getNonOperatingExpenses = year =>
    this.getObjectValue(this.getObject(year), "non_operating_expenses");

  /**
   * getIncomeBeforeTaxes
   */
  getIncomeBeforeTaxes = year =>
    this.getOperatingProfits(year) - this.getNonOperatingExpenses(year);

  /**
   * getTaxes
   */
  getTaxes = year =>
    this.getIncomeBeforeTaxes(year) < 0
      ? 0
      : this.getIncomeBeforeTaxes(year) * 0.3 * -1;
  /**
   * getNetIncome
   */
  getNetIncome = year =>
    this.getIncomeBeforeTaxes(year) - Math.abs(this.getTaxes(year));

  get netIncomeYear1() {
    return this.getNetIncome(this.year1);
  }

  get showEditModal() {
    const {
      roundInUrl,
      currentRound,
      rounds,
      hasAccess,
      roundShouldBeFinished
    } = this.props;

    if (hasAccess === false) {
      return false;
    }

    if (roundShouldBeFinished === true) {
      return false;
    }

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);

    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  render() {
    const {
      currentRound,
      onSave,
      hasAccess,
      showRoleAlert,
      tourMode
    } = this.props;
    const divStyle = this.isMobile
      ? {
          padding: 0,
          marginBottom: 0
        }
      : {};

    return this.props.showModalState ? (
      <ProjectionsModal
        year_number1={this.year1}
        year1={this.objectYear1}
        year2={this.objectYear2}
        year3={this.objectYear3}
        currentRound={currentRound}
        onSave={onSave}
        hasAccess={hasAccess}
        showRoleAlert={showRoleAlert}
        tourMode={tourMode}
        showModalState={this.props.showModalState}
        showModal={this.props.showModal}
        hideModal={this.props.hideModal}
      />
    ) : (
      <div className="panel-dashboard-white" style={divStyle}>
        <div id="ceo-decisions-edit-projections">
          {this.showEditModal === true && (
            <button
              type="button"
              className="btn btn-make-projection btn-primary"
              onClick={this.props.showModal}
            >
              Make Projections
            </button>
          )}
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th className="table-title text-center">
                  <span />
                </th>
                <th className="table-title text-center">
                  <span>YEAR {this.year1}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center">
                <th className="text-left">Gross Profits</th>
                <td>
                  <AbbreviatedMillionNumberFormat
                    value={this.grossProfitsYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="text-left">Operating Profits</th>
                <td>
                  <AbbreviatedMillionNumberFormat
                    value={this.operatingProfitsYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="text-left">Net Profits</th>
                <td>
                  <AbbreviatedMillionNumberFormat
                    value={this.netIncomeYear1}
                    prefix="$"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default CollapseWidget;



// WEBPACK FOOTER //
// ./src/components/ceo/decisions/collapse-widget.js